import React from 'react';
import { IoRibbon, IoTrophy, IoPeople } from 'react-icons/io5';
import Card from '../../components/common/Card/Card';
import ImagePlaceholder from '../../components/common/ImagePlaceholder/ImagePlaceholder';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import { APP_CONFIG } from '../../constants/config';
import './About.css';

/**
 * Página Nosotros - Colegio Bertolt Brecht
 */
const About = () => {
    return (
        <div className="about">
            {/* Page Header */}
            <PageHeader
                title="Nosotros"
                subtitle="Conoce nuestra historia, misión y valores que nos definen"
            />

            <div className="container">
                {/* Misión y Visión */}
                <section className="about__mission-vision">
                    <div className="about__mv-grid">
                        <Card className="about__mv-card about__mv-card--mission">
                            <div className="about__mv-icon">
                                <IoRibbon />
                            </div>
                            <h2>Nuestra Misión</h2>
                            <p>{APP_CONFIG.mission}</p>
                        </Card>

                        <Card className="about__mv-card about__mv-card--vision">
                            <div className="about__mv-icon">
                                <IoTrophy />
                            </div>
                            <h2>Nuestra Visión</h2>
                            <p>{APP_CONFIG.vision}</p>
                        </Card>
                    </div>
                </section>

                {/* Nuestra Esencia */}
                <section className="about__essence">
                    <h2 className="about__section-title">Nuestra Esencia</h2>
                    <div className="about__essence-grid">
                        <Card hoverable className="about__essence-card">
                            <div className="about__essence-icon">⭐</div>
                            <h3>Experiencia</h3>
                            <p>Más de {APP_CONFIG.yearsOfExperience} años formando estudiantes exitosos y comprometidos con la sociedad</p>
                        </Card>

                        <Card hoverable className="about__essence-card">
                            <div className="about__essence-icon">🎯</div>
                            <h3>Metodología Propia</h3>
                            <p>"Enfocado en el Aprendizaje" - Un enfoque único que pone al estudiante en el centro</p>
                        </Card>

                        <Card hoverable className="about__essence-card">
                            <div className="about__essence-icon">💡</div>
                            <h3>Desarrollo Integral</h3>
                            <p>Formación académica, personal, social y emocional de cada estudiante</p>
                        </Card>
                    </div>
                </section>

                {/* Valores */}
                <section className="about__values">
                    <h2 className="about__section-title">Nuestros Valores</h2>
                    <div className="about__values-grid">
                        {APP_CONFIG.values.map((value, index) => (
                            <Card
                                key={value.name}
                                hoverable
                                className={`about__value-card animate-scale-in animate-delay-${Math.min(index + 1, 4)}`}
                            >
                                <div className="about__value-icon">{getValueIcon(value.name)}</div>
                                <h3>{value.name}</h3>
                                <p>{value.description}</p>
                            </Card>
                        ))}
                    </div>
                </section>

                {/* Principio Ético */}
                <section className="about__ethical">
                    <div className="about__ethical-content">
                        <div className="about__ethical-icon">
                            <IoPeople />
                        </div>
                        <div className="about__ethical-text">
                            <h3>Principio Ético</h3>
                            <p>"{APP_CONFIG.ethicalPrinciple}"</p>
                        </div>
                    </div>
                </section>

                {/* Instalaciones */}
                <section className="about__facilities">
                    <h2 className="about__section-title">Nuestras Instalaciones</h2>
                    <div className="about__facilities-grid">
                        <div className="about__facility-item">
                            <ImagePlaceholder
                                aspectRatio="4/3"
                                icon="🏫"
                                alt="Instalaciones"
                            />
                            <h4>Instalaciones</h4>
                        </div>
                        <div className="about__facility-item">
                            <ImagePlaceholder
                                aspectRatio="4/3"
                                icon="📚"
                                alt="Biblioteca"
                            />
                            <h4>Biblioteca</h4>
                        </div>
                        <div className="about__facility-item">
                            <ImagePlaceholder
                                aspectRatio="4/3"
                                icon="🔬"
                                alt="Laboratorio"
                            />
                            <h4>Laboratorio</h4>
                        </div>
                        <div className="about__facility-item">
                            <ImagePlaceholder
                                aspectRatio="4/3"
                                icon="⚽"
                                alt="Deportes"
                            />
                            <h4>Deportes</h4>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

// Helper function para iconos de valores
const getValueIcon = (valueName) => {
    const icons = {
        'Liderazgo': '👑',
        'Participación': '🤝',
        'Solidaridad': '❤️',
        'Responsabilidad': '✅',
        'Disciplina': '📋'
    };
    return icons[valueName] || '⭐';
};

export default About;
